import { useMemo } from 'react';

import { computeProjection, type ProjectionResult } from '@/domain/engine';
import { useSimulatorState } from '@/store/useSimulatorState';

export function useProjection(): ProjectionResult {
  const state = useSimulatorState();
  return useMemo(() => computeProjection(state), [state]);
}
